var render = function render(){var _vm=this,_c=_vm._self._c;return _c('bsh-modal',{attrs:{"titulo":_vm.fileName,"tamanho":"modal-lg","name":_vm.name},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('div',{staticClass:"form-row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('img',{attrs:{"src":_vm.imgUrl,"width":"100%","height":"100%"}})])])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }